import {
  UPDATE_PLACES_FORM,
  UPDATE_PLACES_FORM_SUCCESS,
  UPDATE_PLACES_FORM_FAILED,
  GET_PLACES_MENU_ITEM,
  GET_PLACES_MENU_ITEM_SUCCESS,
  GET_PLACES_MENU_ITEM_FAILED,
  RESET_PLACES_MENU_ITEM,
  GET_SURVEY,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILED,
} from "./actionTypes"

export const getSurvey = params => ({
  type: GET_SURVEY,
  payload: params,
})

export const getSurveySuccess = response => ({
  type: GET_SURVEY_SUCCESS,
  payload: response,
})

export const getSurveyFailed = error => ({
  type: GET_SURVEY_FAILED,
  payload: error,
})

export const updatePlacesForm = params => ({
  type: UPDATE_PLACES_FORM,
  payload: params,
})

export const updatePlacesFormSuccess = response => ({
  type: UPDATE_PLACES_FORM_SUCCESS,
  payload: response,
})

export const updatePlacesFormFailed = error => ({
  type: UPDATE_PLACES_FORM_FAILED,
  payload: error,
})

export const getPlacesMenuItem = params => ({
  type: GET_PLACES_MENU_ITEM,
  payload: params,
})

export const getPlacesMenuItemSuccess = response => ({
  type: GET_PLACES_MENU_ITEM_SUCCESS,
  payload: response,
})

export const getPlacesMenuItemFailed = error => ({
  type: GET_PLACES_MENU_ITEM_FAILED,
  payload: error,
})

export const resetPlacesMenuItem = () => ({
  type: RESET_PLACES_MENU_ITEM,
  payload: {},
})
